import { API_URL } from '../../../app-config/constants';
import { post } from '../request';

const BASE_URL = `${API_URL}/drafts`;

export function save(draft) {
    return post(BASE_URL, {
        postData: draft,
    });
}
